import { captureEvent } from '~/analytics/posthog';
import api from '~/services/api';
import { CONTRACT_RESPONSE, QUOTE_PRODUCTS, QUOTE_RESPONSE } from '../../variables';
import { CustomerRequestParams, PaymentRequestParams, QuoteProductsRequestParams, QuoteRequestParams } from './types';

class QuoteService {
  async postQuote(payload: QuoteRequestParams) {
    console.log('QuoteService', payload);
    const {
      data: { data }
    } = await api.v2!.post('/Quotes', payload);

    // Só metadados seguros: o payload tem nome, e-mail e documento do cliente.
    captureEvent('QuoteService payload', { plan_id: payload.plan_id, equipment_type_id: payload.equipment_type_id });
    console.log('QuoteService payload', payload);
    captureEvent('QuoteService data', {
      quote_hash: (data as { quote_hash?: string })?.quote_hash,
      quotes: (data as { quotes?: unknown[] })?.quotes?.length
    });
    console.log('QuoteService data', data);
    localStorage.setItem(QUOTE_RESPONSE, JSON.stringify(data));
    return data;
  }
  localQuote() {
    const userDataString = localStorage.getItem(QUOTE_RESPONSE);
    const userData = userDataString && JSON.parse(userDataString);
    const quotes = userData?.quotes;
    delete userData?.quotes;
    const CONTRACT_RESPONSEString = localStorage.getItem(CONTRACT_RESPONSE);
    const contractResponse = CONTRACT_RESPONSEString;
    return { quotes, quoteResponse: userData, contractResponse };
  }
  async postQuoteCustomer(quoteHash: string, payload: CustomerRequestParams) {
    const hash = quoteHash?.trim();
    if (!hash) {
      throw new Error('postQuoteCustomer: quoteHash é obrigatório');
    }
    const { data } = await api.v2!.put(`/Quotes/${hash}/customer`, payload);
    return data;
  }
  async postQuotePayment(payment: PaymentRequestParams) {
    const {
      data: { data }
    } = await api.v2!.post(`/Contracts`, payment);
    // Nunca o payload cru: ele tem o card_hash e o endereço fiscal.
    captureEvent('PaymentPayload', { quote_id: payment.quote_id, payment_method: payment.payment?.payment_method });
    captureEvent('PaymentResponse', { contract_id: data?.contract_id });
    localStorage.setItem(CONTRACT_RESPONSE, data.contract_id);
    return data;
  }
  async updateQuote(quoteHash: string, payload: QuoteProductsRequestParams) {
    const { data } = await api.v2!.put(`/Quotes/${quoteHash}`, payload);
    localStorage.setItem(QUOTE_PRODUCTS, JSON.stringify(data));
    return data;
  }
}

export default new QuoteService();
